const getPostedByForExport = e => {
	//	console.log('getPostedByForExport', e)
	if (e?.userId) {
		return `${e.userId.firstName || ''} ${e.userId.lastName || ''} (${e.userId.mobile || ''})`
	}

	if (e?.hubAdmin) {
		return `${e?.hub?.admin?.firstName || ''} ${e?.hub?.admin?.lastName || ''} ${e?.hub?.admin
			?.mobile || ''} (Community Admin)`
	}

	if (e?.sansthAdmin || e?.sansthaAdmin) {
		return `${e?.sanstha?.admin?.firstName || ''} ${e?.sanstha?.admin?.lastName || ''} ${e?.sanstha
			?.admin?.mobile || ''} (Sanstha Admin)`
	}

	if (e?.superAdmin) {
		return 'Super Admin'
	}

	return '—'
}

export default getPostedByForExport
